"use client";

import React, { useState } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import LogoWithSparkle from './LogoWithSparkle';
import ChatInterface from './ChatInterface';

interface ChatBotProps {
  businessIdentifier: string;
}

const ChatBot: React.FC<ChatBotProps> = ({ businessIdentifier }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  const closeChat = () => {
    setIsOpen(false);
  };

  return (
    <Box
      position="fixed"
      bottom="24px"
      right="24px"
      zIndex={1000}
    >
      <Box
        position="absolute"
        bottom="64px"
        right="0"
        mb="8px"
        transition="all 0.3s ease-in-out"
        opacity={isOpen ? 1 : 0}
        transform={isOpen ? "translateY(0)" : "translateY(20px)"}
        pointerEvents={isOpen ? "auto" : "none"}
        width="350px"
      >
        <ChatInterface onClose={closeChat} businessIdentifier={businessIdentifier} />
      </Box>
      
      <Box
        cursor="pointer"
        transition="all 0.2s ease-in-out"
        _hover={{ transform: "scale(1.05)" }}
        _active={{ transform: "scale(0.95)" }}
        onClick={toggleChat}
        position="relative"
        zIndex={1001}
      >
        <LogoWithSparkle />
      </Box>
    </Box>
  );
};

export default ChatBot; 